<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="main-box">
      <div class="btn">
        <el-button
          class="down_btn"
          round
          type="primary"
          icon="el-icon-download"
          @click="downLoad"
          >下载</el-button
        >
      </div>

      <div class="pdf-box" @scroll="handleScroll">
        <!-- <el-progress class="progress" color="#53a7ff"
              :percentage="Math.floor((loadedRatio / totalPages) * 100)">
            </el-progress> -->
        <div class="pdf-scale-box">
          <!-- {{ loadedRatio }}/{{ totalPages }} -->
          <pdf
            v-for="i in totalPages"
            :key="i"
            :src="selectedUrl"
            :page="i"
            @page-loaded="loadedRatio++"
          ></pdf>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: { pdf },
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/investDanger` },
        { name: "隐患排查", path: `/vehicle/investDanger` },
        { name: "文件预览" },
      ],
      selectedUrl: "/fleet/hazardweekly/pdf?mode=preview&id=",
      totalPages: 1,
      pageHeight: 0,
      tabIdx: 0,
      count: 1,
      step: 5,
      loadedRatio: 0,
      id: null,
    };
  },
  methods: {
    getPageHeight() {
      const page = document.querySelector(".pdf-box");
      // console.log(page.offsetHeight)
      this.pageHeight = page.offsetHeight;
    },
    handleScroll(event) {
      const sTop = event.target.scrollTop;
      // 处理滚动事件
      // console.log(sTop); // 输出滚动位置
      // console.log(this.menu[this.tabIdx])
      // 滚动到倒数第3页
      if (sTop >= this.pageHeight * (this.totalPages - 3)) {
        console.log("start");
        this.count++;
        // const num = this.count * this.step;
        // const o = this.menu[this.tabIdx];
        // if (o.totalPages >= num) {
        //   this.totalPages = num;
        // } else {
        //   this.totalPages = o.totalPages;
        // }
      }
    },

    getNumPages(o) {
      // console.log({ ...o })
      let loadingTask = pdf.createLoadingTask(o.url);
      // console.log(loadingTask)
      loadingTask.promise
        .then((pdf) => {
          // console.log(pdf)
          o.totalPages = pdf.numPages;
          console.log(o.totalPages);
          const num = this.count * this.step;
          if (o.totalPages >= num) {
            this.totalPages = num;
          } else {
            this.totalPages = o.totalPages;
          }
        })
        .catch((error) => {
          console.error("pdf加载失败", error);
        });
    },
    downLoad() {
      const a = document.createElement("a");
      a.href = this.selectedUrl.replace("preview", "download");
      a.click();
    },
  },
  created() {
    this.pdf = require("vue-pdf");
    console.log("获取的pdf", this.pdf);
  },
  mounted() {
    const { id, mode } = this.$route.query;
    this.id = id;
    if (mode == "month") {
      this.selectedUrl = this.IP + "/fleet/hazardmonthly/pdf?mode=preview&id=" + id;
    } else {
      this.selectedUrl = this.IP + this.selectedUrl + id;
    }
    // console.log(this.IP, this.id);
    console.log(this.selectedUrl);
    this.getNumPages({
      url: this.selectedUrl,
    });
    this.$nextTick(() => {
      this.getPageHeight();
    });
  },
};
</script>

<style lang="less" scoped>
.main-box {
  display: flex;
  height: calc(100vh - 150px);
  position: relative;

  > .btn {
    position: absolute;
    right: 27px;
    top: -50px;
    z-index: 99;
  }

  .pdf-box {
    height: calc(100vh - 150px);
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    // border: 1px solid #707070;
    // background-color: #fff;

    &::-webkit-scrollbar {
      width: 10px;
      // height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
      cursor: pointer;
    }

    .pdf-scale-box {
      width: 1664px;

      .progress {
        width: 100%;
        position: fixed;
        top: 0;
        z-index: 999;
      }
    }
  }
}
</style>
